module.exports = __webpack_public_path__ + "static/media/mobiles_gif.cf7dcddc.png";